/**
 * Maps the current pathname to a "module" key consumed by the
 * `[data-module]` CSS rules in src/index.css. Returns one of:
 *   "dashboard" | "marketplace" | "ai" | "reports" | "assessment"
 *   | "experts" | "innovation"
 *
 * Default ("dashboard") keeps the existing executive-blue palette.
 */
export type SectionModule =
  | "dashboard"
  | "marketplace"
  | "ai"
  | "reports"
  | "assessment"
  | "experts"
  | "innovation";

export function resolveSectionModule(pathname: string): SectionModule {
  const p = pathname.toLowerCase();

  // Reports — assessment report/summary/audit pages
  if (/^\/assessments\/[^/]+\/(report|summary|audit)/.test(p)) return "reports";

  if (p.startsWith("/ai-insights")) return "ai";

  if (p.startsWith("/marketplace") || p.startsWith("/admin/marketplace")) {
    return "marketplace";
  }

  if (
    p.startsWith("/expert") ||
    p.startsWith("/my-bookings") ||
    p.startsWith("/services") ||
    p.startsWith("/admin/service")
  ) {
    return "experts";
  }

  if (
    p.startsWith("/assessments") ||
    p.startsWith("/framework") ||
    p.startsWith("/approvals") ||
    p.startsWith("/reviews") ||
    p.startsWith("/age-friendly-index")
  ) {
    return "assessment";
  }

  if (p.startsWith("/vendor") || p.startsWith("/admin/vendor")) {
    return "innovation";
  }

  return "dashboard";
}

export function useSectionTheme(pathname: string): SectionModule {
  return resolveSectionModule(pathname);
}
